module.exports = __webpack_public_path__ + "img/market_research_banner.41db1d29.jpg";